import { Menu } from "antd";

export const buildStatusMenu = (onSelect) => ({
  items: [
    { key: "all", label: "All" },
    { key: "active", label: "Active Only" },
    { key: "inactive", label: "Inactive Only" },
  ],
  onClick: onSelect,
});
